import { RootState } from '../../root_reducer';
import { Store } from '../interfaces';

export default (store: RootState): Store => store.application;
